import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { order_model, Payment_Data, PaymentSuccessResult } from 'src/app/models/basket';
import { TraceClassDecorator } from '@sentry/angular';
import {
    PackagesData
} from 'src/app/models/package';
import { ApiResult } from 'src/app/models/PromiseResult';
import { PackagesService } from 'src/app/services/packages.service';
import { PaymentComponent } from '../../shared/payment/payment.component';
import { name_input } from './../../../constant/constant';
import { Router } from '@angular/router';
import { PatientService } from 'src/app/services/patient.service';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { URLS } from '../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';
enum PAYMENT_FORMS_TABS {
    PACKAGE_FORM = 0,
    PAYMENT_FORMS = 1,
    PAYMENT_SUCCESS = 2,

}

@TraceClassDecorator()
@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.css']
})
export class PackagesComponent implements OnInit {

    @ViewChild(PaymentComponent) payment_screen: PaymentComponent;

    readonly name_input: RegExp = name_input;

    packagesData: PackagesData = new PackagesData(0, 2)
    is_uk_country: boolean = false;
    slug: string = "";
    is_primary_provider: boolean = false;
    constructor(
        private readonly router: Router,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly packagesService: PackagesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly patientService: PatientService,
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
            { label: 'Packages' }
        ]);
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        await this.findPackageStatus();
    }

    async findPackageStatus() {
        this.packagesData.packages_list_api_result = new ApiResult(true);
        await this.packagesService
            .status()
            .toPromise()
            .then((result) => {

                this.packagesData.packages_list_api_result.PromiseResult = result;
                if (result.success) {
                    this.packagesData.packages = result.data.packages;
                    this.packagesData.country = result.data.country;
                    this.packagesData.package_status = result.data.status;
                    if (this.packagesData.packages.length > 0) {
                        this.selectPackage(this.packagesData.packages[0].id); // by defualt selected the lowest one
                    }
                }
                this.packagesData.packages_list_api_result.Posting = false;
                this.packagesData.package_status.forEach(status => {
                    status.user_package_count = status.user_package_count.filter(packageCount => packageCount.current_count > 0)
                })
            })
            .catch((error: HttpErrorResponse) => {
                this.packagesData.packages_list_api_result.ServerError = error.error;
                this.packagesData.packages_list_api_result.PromiseResult.success = false;
                this.packagesData.packages_list_api_result.Posting = false;
            });
    }


    async submitPackages() {
        this.packagesData.packages_submit_api_result = new ApiResult(true);
        this.packagesData.paymentData.payment_start_api_result = new ApiResult(true);
        this.packagesData.paymentData = new Payment_Data();
        await this.packagesService
            .purchase(this.packagesData.selected_packages)
            .toPromise()
            .then(async (result) => {
                this.packagesData.packages_submit_api_result.PromiseResult = result;
                this.packagesData.paymentData.payment_start_api_result.PromiseResult = result;
                if (result.success) {
                    this.packagesData.paymentData.stripe_checkout_url = result.data.stripe_checkout_url;
                    const order: order_model = result.data;

                    this.packagesData.paymentData.order_data = order;
                    await this.start_payment();
                }
                // else {
                //     this.packagesData.paymentData.payment_start_api_result.ErrorModel=result.error
                // }
                this.packagesData.paymentData.payment_start_api_result.Posting = false
                this.packagesData.packages_submit_api_result.Posting = false;
            }).catch((error) => {
                this.packagesData.packages_submit_api_result.ServerError = error.error;
                this.packagesData.packages_submit_api_result.PromiseResult.success = false;
                this.packagesData.packages_submit_api_result.Posting = false;
                this.packagesData.paymentData.payment_start_api_result.ServerError = error.error;
                this.packagesData.paymentData.payment_start_api_result.PromiseResult.success = false;
                this.packagesData.paymentData.payment_start_api_result.Posting = false;
            });
    }

    async openInvoice() {
        this.packagesData.print_data.api_result = new ApiResult(true)
        this.packagesData.print_data.displayModal = true;
        await this.patientService
            .fetchInvoice(this.packagesData.paymentData.paymentSuccessData.consultationData.transaction_id)
            .toPromise()
            .then((result) => {
                this.packagesData.print_data.api_result.PromiseResult = result;
                if (result.success) {
                    this.packagesData.print_data.data = result.data;
                }
                else {
                    this.packagesData.print_data.api_result.ErrorModel = result.error;
                }
                this.packagesData.print_data.api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.packagesData.print_data.api_result.ServerError = error.error;
                this.packagesData.print_data.api_result.PromiseResult.success = false;
                this.packagesData.print_data.api_result.Posting = false;
            });
    }


    async start_payment() {
        this.changeDetector.detectChanges();
        await this.payment_screen.load_payment_gateway();
    }

    onPaymentSuccess(data: PaymentSuccessResult) {
        this.packagesData.paymentData.paymentSuccessData = data;
        this.packagesData.tabview_Data.nextTab();
    }

    async nextTab() {
        switch (this.packagesData.tabview_Data.selected_tab) {
            case PAYMENT_FORMS_TABS.PACKAGE_FORM:
                await this.submitPackages();
                this.packagesData.tabview_Data.nextTab();
                break;
            default:
                break;
        }
    }

    async prevTab() {
        this.packagesData.tabview_Data.prevTab();
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/patient/' + path]);
    }

    print() {
        window.print();
    }

    isPosting(): boolean {
        return this.packagesData.packages_list_api_result.Posting ||
            this.packagesData.packages_submit_api_result.Posting || this.packagesData.paymentData.transaction_submit_api_result.Posting;
    }

    selectPackage(package_id: string) {
        this.packagesData.selected_packages.package_id = package_id;
    }

    isCurrentPackageSelected(package_id: string): boolean {
        return this.packagesData.selected_packages.package_id == package_id;
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

}
